var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ma-3"},[_c('v-data-table',{attrs:{"headers":_vm.fuelHeaders,"items":_vm.fuels}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }